import React, { useState } from 'react';
import { Box } from '@mui/material';

import HistoryIcon from '@mui/icons-material/History';
import SaveIcon from '@mui/icons-material/Save';


export default function BaseWindow(props) {
    const {parentRef, children} = props


    return (
        <React.Fragment>
            <Box
                m={4}
                width={'100%'}
                sx={{
                    flex: 1,
                    overflow: 'hidden', 
                    border: '2px solid rgba(107, 164, 125, 0.2)',
                    borderRadius: '8px'
            }}>
                <Box
                    sx={{ 
                        width:'100%',
                        height:'100%',
                        overflow: 'auto'
                    }}
                >
                    {children}
                </Box>
            </Box>
        </React.Fragment>
    )
}